import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import "./create-scratch-empty-state.scss";

type TScratchEmptyStateTheme = "purple" | "blue" | "green";

interface ICreateScratchEmptyStateProps {
  theme: TScratchEmptyStateTheme;
  iconName: "ai-action" | "ai-agent" | "vision-action";
  title: string;
  description: string;
  learnMoreLink?: string;
  features: string[];
  onBack: () => void;
  onStart: () => void;
  startButtonLabel?: string;
  learnMoreButtonLabel?: string;
}

const heroImageByIconName: Record<ICreateScratchEmptyStateProps["iconName"], string> = {
  "ai-action": "/images/create-scratch-empty-state-ai-action.svg",
  "ai-agent": "/images/create-scratch-empty-state-ai-agent.svg",
  "vision-action": "/images/create-scratch-empty-state-vision-action.svg"
};

function CreateScratchEmptyState({
  theme,
  iconName,
  title,
  description,
  learnMoreLink,
  features,
  onBack,
  onStart,
  startButtonLabel = "Start Building",
  learnMoreButtonLabel = "Learn More"
}: ICreateScratchEmptyStateProps) {
  const heroImageSrc = heroImageByIconName[iconName];

  const handleLearnMoreClick = () => {
    if (!learnMoreLink) return;
    window.open(learnMoreLink, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`kuika-create-scratch-empty-state kuika-create-scratch-empty-state--${theme}`}>
      <div className="kuika-create-scratch-empty-state__hero">
        <img
          src={heroImageSrc}
          alt="Create from a blank preview"
          className="kuika-create-scratch-empty-state__hero-image"
        />
      </div>
      <div className="kuika-create-scratch-empty-state__card">
        <div className="kuika-create-scratch-empty-state__header">
          <div className="kuika-create-scratch-empty-state__icon-wrapper">
            <KuikaSvg type="datasource-icons" name={iconName} width={24} height={24} />
          </div>
          <div className="kuika-create-scratch-empty-state__header-content">
            <h3 className="kuika-create-scratch-empty-state__title">{title}</h3>
            <p className="kuika-create-scratch-empty-state__description">
              {description}{" "}
              {learnMoreLink && (
                <KuikaButton
                  type="tertiary"
                  onClick={handleLearnMoreClick}
                  className="kuika-create-scratch-empty-state__description-button"
                >
                  {learnMoreButtonLabel}
                </KuikaButton>
              )}
            </p>
          </div>
        </div>

        <div className="kuika-create-scratch-empty-state__features">
          {features.map((feature) => (
            <div className="kuika-create-scratch-empty-state__feature" key={feature}>
              <KuikaSvg
                type="common"
                name="check"
                width={16}
                height={16}
                className="kuika-create-scratch-empty-state__check"
              />
              <span>{feature}</span>
            </div>
          ))}
        </div>

        <div className="kuika-create-scratch-empty-state__actions">
          <KuikaButton type="primary" onClick={onStart}>
            {startButtonLabel}
          </KuikaButton>
        </div>
      </div>
    </div>
  );
}

export default CreateScratchEmptyState;
